import Fuse from 'fuse.js';
import { useSelector } from 'react-redux';

/**
 * @description - This function is used to generate search fuses for all the searchable fields.
 * @author Kishan Virani
 * @date 12/07/2022
 * @return {*}
 */
// library/helpers/useGlobalSearchObjGenerator.js

import { selectAssetGroups } from 'reduxStore/assetGroups/selectors';
import { selectBookings } from 'reduxStore/bookings/selectors';
import { selectCategories } from 'reduxStore/categories/selectors';
import { selectCredentials } from 'reduxStore/credentials/selectors';
import { selectDevices, selectLockersDevices } from 'reduxStore/devices/selectors';
import { selectPeople } from 'reduxStore/people/selectors';
import { selectTeams } from 'reduxStore/teams/selectors';

export const useGlobalSearchObjGenerator = () => {
	const searchAbleField = useSelector((s) => s.FbRemoteConfig?.remoteConfig?.searchAbleField ?? {});

	const people = useSelector(selectPeople);
	const teams = useSelector(selectTeams);
	const devices = useSelector(selectDevices);
	const deviceGroups = useSelector(selectAssetGroups);
	const categories = useSelector(selectCategories);
	const credentials = useSelector(selectCredentials);
	const lockers = useSelector(selectLockersDevices);
	const bookings = useSelector(selectBookings);

	const enrichedDevices =
		devices?.map((device) => {
			const category = categories?.find((cat) => cat?.categoryID === device?.categoryID);
			return {
				...device,
				categoryName: category?.name || ''
			};
		}) || [];

	const enrichedLockers =
		lockers?.map((locker) => {
			const deviceBooking = bookings?.find((booking) => booking.deviceID === locker?.deviceID);
			const assignedPerson = deviceBooking?.assignedToPerson
				? people?.find((person) => person.personID === deviceBooking.assignedToPerson)
				: null;

			return {
				...locker,
				bookedByPersonName: assignedPerson?.displayName || assignedPerson?.name || ''
			};
		}) || [];
	function makeFuse(list, keys, label) {
		return new Fuse(list, {
			keys: keys || [],
			includeScore: true,
			threshold: 0.3
		});
	}

	const fuses = {
		'People': makeFuse(people, searchAbleField['people'], 'People'),
		'Teams': makeFuse(teams, searchAbleField['teams'], 'Teams'),
		'Devices': makeFuse(enrichedDevices, searchAbleField['devices'], 'Devices'),
		'Device Groups': makeFuse(deviceGroups, searchAbleField['assetGroups'], 'DeviceGroups'),
		'Categories': makeFuse(categories, searchAbleField['deviceCategory'], 'Categories'),
		'Credentials': makeFuse(credentials, searchAbleField['credentials'], 'Credentials'),
		'Lockers': makeFuse(enrichedLockers, searchAbleField['lockers'], 'Lockers')
	};

	return fuses;
};
